import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-vehicle-approval-link',
  templateUrl: './asset-vehicle-approval-link.component.html',
  styleUrls: ['./asset-vehicle-approval-link.component.scss']
})
export class AssetVehicleApprovalLinkComponent {

}
